import { Intent, Button, Icon } from '@blueprintjs/core';
import { css } from '@stitches/react';
import { StartPointProps } from '@moleculeone/types';

import { apiQueryClient } from '@f/api-client';

interface ReactionConditionsButtonProps extends StartPointProps {
  onClick: () => void;
}

const buttonStyle = css({
  borderRadius: '50px',
});

export function ReactionConditionsButton(props: ReactionConditionsButtonProps) {
  const { point, scale, padding, reactionData, onClick } = props;

  const reactionSmiles = `${reactionData?.substrateSmiles.join('.')}>>${
    reactionData?.productSmiles
  }`;

  const classifyReactionQueryKey = ['reactionConditions', reactionSmiles];
  // @ts-ignore
  const { data: reactionClassesData, isLoading: isClassifyingReaction } =
    apiQueryClient.reactionConditions.classifyReaction.useQuery(
      classifyReactionQueryKey,
      {
        query: {
          reactionSmiles,
        },
      },
      {
        queryKey: classifyReactionQueryKey,
        enabled: reactionData != null,
        staleTime: Infinity,
      }
    );
  const reactionClasses = reactionClassesData?.body ?? [];
  const foundSomeReactionClass = reactionClasses.length > 0;

  if (!foundSomeReactionClass) {
    return null;
  }

  const endPointProps = {
    x: point[0],
    y: point[1],
    width: 45,
    height: 45,
  };

  return (
    <foreignObject
      x={endPointProps.x - endPointProps.width / 2 / scale - padding / scale}
      y={endPointProps.y - endPointProps.height / 2}
      width={endPointProps.width}
      height={endPointProps.height}
      style={{
        transform: `scale(${scale * 0.75}, ${scale * 0.75})`,
        transformOrigin: `${endPointProps.x - endPointProps.width / scale}px ${
          endPointProps.y - endPointProps.height / scale
        }px`,
        overflow: 'visible',
      }}
    >
      <Button
        className={buttonStyle()}
        intent={Intent.WARNING}
        onClick={onClick}
        data-test={`reaction-conditions-button`}
        loading={isClassifyingReaction}
        style={{
          transform: `translateX(${(1.5 * endPointProps.width) / scale}px)`,
        }}
      >
        <Icon icon="settings" />
      </Button>
    </foreignObject>
  );
}
